/* The limitation chip and its info control, side by side and allowed to wrap inside a narrow tile. */
.row {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
